<template>
  <v-container fluid class="salesreport-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row align="center" no-gutters>
            <v-col v-if="find_query.userid!=null" cols="12" md="3" class="d-flex justify-space-between justify-md-start">
                <div>
                  <v-avatar v-if="users.find(user=>user._id == find_query.userid)['userimage']!==''" size="40">
                    <img v-bind:src="users.find(user=>user._id == find_query.userid)['userimage']" alt="">
                  </v-avatar>
                  <v-avatar v-else color="warning" size="40">
                    <span class="white--text headline">{{ users.find(user=>user._id == find_query.userid)['username'][0].toUpperCase() }}</span>
                  </v-avatar>
                  <span style="margin-left:15px">{{ users.find(user=>user._id == find_query.userid)['username'] }}</span>
                </div>
            </v-col>
            <v-col cols="12" md="3" class="d-flex justify-space-between justify-md-start">
              <div>
                <div style="display: block; margin: 0;" v-if="find_query.brandid!=null"><span><b>Brand:</b> {{ brands.find(brand=>brand._id == find_query.brandid)['brandname'] }}</span></div> 
                <div style="display: block; margin: 0;" v-if="find_query.regionid!=null"><span><b>Region:</b> {{ regions.find(region=>region._id == find_query.regionid)['regionname'] }}</span></div> 
                <div style="display: block; margin: 0;" v-if="find_query.townshipid!=null"><span><b>Township:</b> {{ townships.find(town=>town._id == find_query.townshipid)['townshipname'] }}</span></div> 
                <div style="display: block; margin: 0;" v-if="find_query.startdate!=null || find_query.enddate!=null"><b>Date Range:</b> {{ find_query.startdate }} - {{ find_query.enddate }}</div> 
              </div>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="12" md="3" class="d-flex justify-space-between justify-md-end">
              <v-btn 
                color="success" 
                class="button-shadow mr-3"
                @click="findSalesReportDialog = true"
              >
                <v-icon class="mr-2">mdi-account-search</v-icon>
                Find
              </v-btn>
              <download-excel
                class="btn btn-default"
                :data="getJson()"
                worksheet="My Worksheet"
                type="xls"
                :name="getFileName()"
              >
              <v-btn 
                v-show="salesreports.length>0"
                color="default" 
                class="button-shadow mb-2 mr-0 mr-sm-2"
              >
                <v-icon class="mr-2">mdi-microsoft-excel</v-icon>
                Save
              </v-btn>
              </download-excel>

            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              :loading="isReceiving || isDeleting"
              loading-text="Loading... Please wait"
              class="salesreports-table"
              single-select
              item-key="_id"
              sort-by="salesreportname"
              :footer-props="footer"
              :headers="headers"
              :items="salesreports"
              :items-per-page="itemPerPage">
              <template v-slot:item.startdate="{ item }">
                {{ item.startdate!=null ? new Date(item.startdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) : '' }}
              </template>
              <template v-slot:item.enddate="{ item }">
                {{ item.enddate!=null ? new Date(item.enddate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric'  }) : '' }}
              </template>
              <template v-slot:item.itemimage="{ item }">
                  <img v-bind:src="item.itemimage" alt="" width="60">
              </template>
              <template v-slot:item.amount="{ item }">
                {{ item.amount!==undefined ? (item.amount).toFixed(1) : '' }}
              </template>
              <template v-slot:item.quantity="{ item }">
                {{ item.quantity!==undefined ? (item.quantity).toFixed(1) : '' }}
              </template>
              <template v-slot:item.avgprice="{ item }">
                {{ item.avgprice!==undefined ? (item.avgprice).toFixed(1) : '' }}
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center">
    <v-dialog
      v-model="findSalesReportDialog"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Find Sales Report</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                cols="12"
                sm="12"
                md="12"
              >
                <v-select
                  :items="users.filter(x=>x.userstatus=='Active').map(x => {
                            return {text: x.username, value: x._id};
                          })"
                  v-model="find_query.userid"
                  label="Sales Rep"
                  required
                ></v-select>
              </v-col>
              <v-col
                cols="12"
                sm="12"
                md="12"
              >
                <v-select
                  :items="brands.filter(x=>x.brandstatus=='Active' && x.brandtype=='Brand').map(x => {
                            return {text: x.brandname, value: x._id};
                          })"
                  v-model="find_query.brandid"
                  label="Brand"
                  required
                ></v-select>
              </v-col>
              <v-col
                cols="12"
                sm="12"
                md="12"
              >
                <v-select
                  :items="regions.filter(x=>x.regionstatus=='Active').map(x => {
                            return {text: x.regionname, value: x._id};
                          })"
                  v-model="find_query.regionid"
                  label="Region"
                  required
                ></v-select>
              </v-col>
              <v-col
                cols="12"
                sm="12"
                md="12"
              >
                <v-select
                  :items="townships.filter(x=>x.townshipstatus=='Active').map(x => {
                            return {text: x.townshipname, value: x._id};
                          })"
                  v-model="find_query.townshipid"
                  label="Township"
                  required
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                        <v-menu
                          ref="menu_startdate"
                          v-model="menu_startdate"
                          :close-on-content-click="false"
                          :return-value.sync="find_query.startdate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              outlined
                              dense
                              v-model="find_query.startdate"
                              label="Start Date"
                              v-bind="attrs"
                              v-bind:value="find_query.startdate"
                              v-on="on"
                              persistent-hint
                              single-line hint="Please enter start date">
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="find_query.startdate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_startdate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu_startdate.save(find_query.startdate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                        <v-menu
                          ref="menu_enddate"
                          v-model="menu_enddate"
                          :close-on-content-click="false"
                          :return-value.sync="find_query.enddate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              outlined
                              dense
                              v-model="find_query.enddate"
                              label="End Date"
                              v-bind="attrs"
                              v-bind:value="find_query.enddate"
                              v-on="on"
                              persistent-hint
                              single-line hint="Please enter end date">
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="find_query.enddate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_enddate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu_enddate.save(find_query.enddate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="find_query = {}"
          >
            Clear
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="findSalesReportDialog = false"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="findSalesReport"
          >
            Find
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'SalesReportByItem',
  data() {
    return {
      headers: [
        { text: 'Image', value: 'itemimage' },
        { text: 'Start', value: 'startdate' },
        { text: 'End', value: 'enddate' },
        { text: 'Item', value: 'itemname' },
        { text: 'Qty', value: 'quantity' },
        { text: 'Avg Price', value: 'avgprice' },
        { text: 'Amount', value: 'amount' },
      ],
      footer: {'items-per-page-options': [500, 1000, 5000]},
      itemPerPage: 500,
      selected: [],
      findSalesReportDialog: false,
      find_query: {},
      salesreports: [],
      menu_startdate: null,
      menu_enddate: null,
      offset: 0,
    }
  },
  computed: {
    ...mapState('SalesReport', ['isDeleting', 'isReceiving']),
    ...mapState('Brand', ['brands']),
    ...mapState('Region', ['regions']),
    ...mapState('Township', ['townships']),
    ...mapState('User', ['users']),
  },
  methods: {
    ...mapActions('Brand', ["getBrandsRequest"]),
    ...mapActions('Region', ["getRegionsRequest"]),
    ...mapActions('Township', ["getTownshipsRequest"]),
    ...mapActions('User', ["getUsersRequest"]),
    ...mapActions('SalesReport', ["findSalesReportTeamByItemRequest", "getSalesReportTeamByItemRequest"]),
    async findSalesReport(){
      
      this.findSalesReportDialog = false;
      
      if(Object.keys(this.find_query).length==0){
        let result = await this.getSalesReportTeamByItemRequest();
        this.salesreports = result;
        this.salesreports.push({amount: this.salesreports.reduce(function (last, json) {return last + json.amount;}, 0) });
      }
      else{
        let result = await this.findSalesReportTeamByItemRequest(this.find_query);
        this.salesreports = result;
        this.salesreports.push({amount: this.salesreports.reduce(function (last, json) {return last + json.amount;}, 0) });
      }
      
      
      console.log(this.salesreports);
    },
    getJson(){
      let json = this.salesreports.map(report=>{return {
        start_date: report.startdate!=null ? new Date(report.startdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) : '',
        end_date: report.enddate!=null ? new Date(report.enddate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) : '',
        itemname: report.itemname,
        quantity: report.quantity, 
        avgprice: report.avgprice ? report.avgprice.toFixed(1) : null, 
        amount: report.amount
      }});
      return json;
    },
    getFileName(){
      var d = new Date();
      var name = 'sales-report-' + d.getFullYear() + '-' + (d.getMonth()+1).toString() + '-' + d.getDate() + '-' + (d.getHours().toString() +d.getSeconds().toString());
      return name + '.xls';
    },
    saveExcel() {
      let item = Object.assign({}, this.find_query);
      item.salesreports = this.salesreports;
      this.$router.push({ name: 'SalesReportPrint', params: item })
    },
  },
  async created () {
    let result = await this.getSalesReportTeamByItemRequest();
    this.salesreports = result;
    this.salesreports.push({amount: this.salesreports.reduce(function (last, json) {return last + json.amount;}, 0) });
    
    
    if(this.users.length==0) this.getUsersRequest();
    if(this.brands.length==0) this.getBrandsRequest();
    if(this.regions.length==0) this.getRegionsRequest();
    if(this.townships.length==0) this.getTownshipsRequest();
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
